import React, { useState } from "react";
import { View } from "react-native";

import { buttonStyle } from "../../common/ActionsMenuButton/utils";
import AppTheme from "../../AppTheme";
import { getContactMailUrl, openURL } from "../../../../helpers/utils";
import OperationIcon from "../../common/ActionsMenuButton/icons/OperationIcon";
import InviteIcon from "../../common/ActionsMenuButton/icons/InviteIcon";
import ActionButton from "../../common/ActionsMenuButton/ActionButton";
import AddIcon from "../../common/icons/AddIcon";

export default function IntegrationFabButton({
  refresh,
  connectNewAccount,
  getManaforDesktop,
  style = {},
  mariOptions = {},
}) {
  const [actionButton, setActionButton] = useState(null);

  const actions = [
    <ActionButton.Item
      key={1}
      underline
      hideShadow
      buttonColor="#FFF"
      title="Ask me Anything"
      onPress={() => {
        openURL(getContactMailUrl());
      }}
    >
      <InviteIcon />
    </ActionButton.Item>,
  ];

  if (refresh) {
    actions.push(
      <ActionButton.Item
        hideShadow
        key={2}
        buttonColor="#FFF"
        title="Refresh"
        onPress={refresh}
      >
        <OperationIcon />
      </ActionButton.Item>,
    );
  }
  if (connectNewAccount) {
    actions.push(
      <ActionButton.Item
        hideShadow
        key={3}
        buttonColor="#FFF"
        title="Add another calendar account"
        onPress={connectNewAccount}
      >
        <AddIcon width={25} height={25} onPress={connectNewAccount} />
      </ActionButton.Item>,
    );
  }
  if (getManaforDesktop) {
    actions.push(
      <ActionButton.Item
        hideShadow
        key={4}
        buttonColor="#FFF"
        title="Get Mana for new desktop"
        onPress={getManaforDesktop}
      >
        <AddIcon width={25} height={25} onPress={getManaforDesktop} />
      </ActionButton.Item>,
    );
  }
  return (
    <View
      style={[buttonStyle, style]}
      onLayout={(event) => {
        if (actionButton != null)
          actionButton.setParentLayout(event.nativeEvent.layout);
      }}
    >
      <ActionButton
        mariOptions={mariOptions}
        ref={(r) => setActionButton(r)}
        buttonColor={AppTheme.DEFAULT_COLOR}
        zIndex={999}
        source={"IntegrationsFabButton"}
      >
        {actions}
      </ActionButton>
    </View>
  );
}
